module.exports = __webpack_public_path__ + "static/media/Dustox_gaussian2.2164696d.png";